"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRTLList;

// This list tracks which languages should display in Right-to-Left format by default
// When a new language is added, be sure to update this list.
// These values are intentionally hard-coded
// Should the following language be displayed in RTL by default?
// 'ar-EG' yes
// 'ar-JO' yes
// 'bg-BG'
// 'cs-CZ'
// 'da-DK'
// 'de-DE'
// 'el-GR'
// 'en-US'
// 'es-ES'
// 'fi-FI'
// 'fr-FR'
// 'he-IL' yes
// 'hu-HU'
// 'it-IT'
// 'ja-JP'
// 'ko-KR'
// 'lv-LV'
// 'nb-NO'
// 'nl-NL'
// 'pl-PL'
// 'pt-BR'
// 'pt-PT'
// 'ru-RU'
// 'sv-SE'
// 'tr-TR'
// 'zh-HANS'
// 'zh-HANT'
// 'zh-YUE'
function getRTLList() {
  var rtlList = ['ar-EG', 'ar-JO', 'ar-SA', 'he-IL'];
  return rtlList;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXRSVExMaXN0IiwicnRsTGlzdCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xvY2FsaXphdGlvbi9nZXRSVExMaXN0LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIFRoaXMgbGlzdCB0cmFja3Mgd2hpY2ggbGFuZ3VhZ2VzIHNob3VsZCBkaXNwbGF5IGluIFJpZ2h0LXRvLUxlZnQgZm9ybWF0IGJ5IGRlZmF1bHRcbi8vIFdoZW4gYSBuZXcgbGFuZ3VhZ2UgaXMgYWRkZWQsIGJlIHN1cmUgdG8gdXBkYXRlIHRoaXMgbGlzdC5cblxuLy8gVGhlc2UgdmFsdWVzIGFyZSBpbnRlbnRpb25hbGx5IGhhcmQtY29kZWRcblxuLy8gU2hvdWxkIHRoZSBmb2xsb3dpbmcgbGFuZ3VhZ2UgYmUgZGlzcGxheWVkIGluIFJUTCBieSBkZWZhdWx0P1xuLy8gJ2FyLUVHJyB5ZXNcbi8vICdhci1KTycgeWVzXG4vLyAnYmctQkcnXG4vLyAnY3MtQ1onXG4vLyAnZGEtREsnXG4vLyAnZGUtREUnXG4vLyAnZWwtR1InXG4vLyAnZW4tVVMnXG4vLyAnZXMtRVMnXG4vLyAnZmktRkknXG4vLyAnZnItRlInXG4vLyAnaGUtSUwnIHllc1xuLy8gJ2h1LUhVJ1xuLy8gJ2l0LUlUJ1xuLy8gJ2phLUpQJ1xuLy8gJ2tvLUtSJ1xuLy8gJ2x2LUxWJ1xuLy8gJ25iLU5PJ1xuLy8gJ25sLU5MJ1xuLy8gJ3BsLVBMJ1xuLy8gJ3B0LUJSJ1xuLy8gJ3B0LVBUJ1xuLy8gJ3J1LVJVJ1xuLy8gJ3N2LVNFJ1xuLy8gJ3RyLVRSJ1xuLy8gJ3poLUhBTlMnXG4vLyAnemgtSEFOVCdcbi8vICd6aC1ZVUUnXG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGdldFJUTExpc3QoKTogc3RyaW5nW10ge1xuICBjb25zdCBydGxMaXN0ID0gWydhci1FRycsICdhci1KTycsICdhci1TQScsICdoZS1JTCddO1xuXG4gIHJldHVybiBydGxMaXN0O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFDQTtBQUVBO0FBRUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUVlLFNBQVNBLFVBQVQsR0FBZ0M7RUFDN0MsSUFBTUMsT0FBTyxHQUFHLENBQUMsT0FBRCxFQUFVLE9BQVYsRUFBbUIsT0FBbkIsRUFBNEIsT0FBNUIsQ0FBaEI7RUFFQSxPQUFPQSxPQUFQO0FBQ0QifQ==